import classnames from 'classnames';
import React, { FC } from 'react';
import { isBoard } from '../../../../../utils/media-manager-sdk/boards';
import { useTranslatedItemName } from '../../../../../utils/media-manager-sdk/hooks';
import { isItemRenamable } from '../../../../../utils/media-manager-sdk/items';
import { Input } from '../../../../../components/common';
import { BoardInfo } from '../BoardInfo';
import { ItemName } from '../ItemName';
import { Separator } from '../Separator';
import styles from './EditingItemName.scss';
import { IOuter } from './EditingItemName.types';
import { useRenameItemHandlers } from './useRenameItemHandlers';

export const EditingItemName: FC<IOuter> = ({ item, onRenameComplete }) => {
  const {
    isEditing,
    editingName,
    inputRef,
    handleInputFocus,
    handleRenameComplete,
    handleRenameCancel,
    handleNameChange,
    handleNameClick,
  } = useRenameItemHandlers({ item, onRenameComplete });
  const translatedItemName = useTranslatedItemName(item);

  if (!isItemRenamable(item)) {
    return isBoard(item) ? (
      <BoardInfo name={item.name} description={item.description} />
    ) : (
      <ItemName name={translatedItemName} className={classnames(styles.itemName, styles.notRenamableItemName)} />
    );
  }

  return isEditing ? (
    <>
      <Input
        onChange={handleNameChange}
        onEnterPressed={handleRenameComplete}
        onBlur={handleRenameComplete}
        onEscapePressed={handleRenameCancel}
        value={editingName}
        autoFocus
        ref={inputRef}
        autoSelect={false}
        onFocus={handleInputFocus}
        dataHook="panel-item-name-input"
        className={styles.inputField}
        size="small"
      />
      <Separator />
    </>
  ) : (
    <div onClick={handleNameClick} data-hook="panel-item-name-title">
      <ItemName name={translatedItemName} className={classnames(styles.itemName, styles.itemNameWithHover)} />
    </div>
  );
};
